import { render, staticRenderFns } from "./WidgetDataViewLayout.vue?vue&type=template&id=306f5978&scoped=true&"
import script from "./WidgetDataViewLayout.vue?vue&type=script&lang=js&"
export * from "./WidgetDataViewLayout.vue?vue&type=script&lang=js&"
import style0 from "./WidgetDataViewLayout.vue?vue&type=style&index=0&id=306f5978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306f5978",
  null
  
)

export default component.exports